import GeozoneInfoObj from './GeozoneInfoObj'

export default GeozoneInfoObj